<template>
    <div>
        <label class="btn-primary btn file-uploader">
            Upload File
            <input type="file" name="file" id="file"  v-on:change="uploadFile">
        </label>
    </div>
</template>
<style>
    .file-uploader {
        position: relative;
        overflow: hidden;
        display: inline-block;

        /* Fancy button looking */
        /*border: 2px solid black;*/
        /*border-radius: 5px;*/
        /*padding: 8px 12px;*/
        /*cursor: pointer;*/
    }
    .file-uploader input {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        opacity: 0;
    }
</style>

<script>

    export default {
        props: {
            uploadUrl: {
                type: String,
                default: null
            },
        },
        data: function () {
            return {
                form: new FormData()
            }
        },
        mounted() {
            this.debug('File Uploader component mounted.');
        },
        methods: {
            uploadFile(event) {
                console.log(event.target.files[0]);

                let formData = new FormData();
                formData.append('file', event.target.files[0]);
                for(var pair of formData.entries()) {
                    console.log(pair[0]+ ', '+ pair[1]);
                }
                axios.post(this.uploadUrl, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then((response) => {
                    // this.loadingInstance.close();
                    console.log(response);
                    this.debug(response.data);
                    this.$emit('file-uploaded', response.data);
                }).catch((error) => {
                    // this.loadingInstance.close();
                    this.$message({message: 'There was a problem uploading the file.', type: 'error'});
                });

            },
            debug(message) {
                console.log('FileUploader: ' + message);
            }
        }
    }
</script>